module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Generate Activation',
          to: {
            path: '/code-activation'
          },
        },
        {
          text: 'Detail Kode Aktivasi'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Detail Kode Aktifasi")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n            Detail Kode Aktivasi "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "mb-5 mt-3"
  }, [_c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v("Tanggal Pembuatan")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.generated_date) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Jumlah User")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.code_count) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Paket")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.package_name) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kelas")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.data.grade) + "\n                                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Download")]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "pa-2",
          staticStyle: {
            "min-width": "0 !important"
          },
          attrs: {
            "depressed": "",
            "rouded": "",
            "small": "",
            "height": "33px",
            "color": "#E8F5FA"
          },
          on: {
            "click": function($event) {
              return _vm.downloadFile()
            }
          }
        }, [_c('v-icon', {
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                            mdi-tray-arrow-down\n                                        ")])], 1)], 1)])])]
      },
      proxy: true
    }])
  })], 1)])], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fed71378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/code_activation/components/CodeActivationDetail.vue
// module id = 2177
// module chunks = 1